import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export interface Region {
  id: string
  code: string
  nameEn: string
  nameFr: string
  name: string
  countryCode: string
}

const fetchRegions = async ({
  pageParam = '1',
  country,
  countries,
  continent,
  continents,
  lang,
  search,
}: FetchParams): Promise<PaginatedResponse<Region>> => {
  const params = new URLSearchParams()
  params.append('page', pageParam)
  if (country) {
    params.append('country', country)
  }
  if (countries?.length) {
    countries.forEach((c: string) => params.append('countries', c))
  }
  if (continent) {
    params.append('continent', continent)
  }
  if (continents?.length) {
    continents.forEach((c: string) => params.append('continents', c))
  }
  if (lang) {
    params.append('lang', lang)
  }
  if (search) {
    params.append('search', search)
  }
  
  const { data } = await api.get<PaginatedResponse<Region>>(`/regions?${params.toString()}`)
  return data
}

export const usePaginateRegions = ({
  country,
  countries,
  continent,
  continents,
  lang,
  search,
}: {
  country?: string
  countries?: string[]
  continent?: string
  continents?: string[]
  lang?: 'en' | 'fr' | 'es'
  search?: string
}) => {
  return usePaginate<Region>('regions', fetchRegions, { country, countries, continent, continents, lang, search })
}

